export default __webpack_public_path__ + "static/media/chat-white.704e6311.svg";